import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { Loader } from 'shared/components';
import BackgroundLayout from 'pages/_layouts/BackgroundLayout';
import { externalLogin, externalJwtLogin } from 'modules/auth/actions/externalLogin';
import { isBrowserSupported } from 'shared/utils/checkMobileDevice';
import BrowserNotSupported from 'modules/auth/components/BrowserNotSupported';

import theme from './ExternalLoginPage.scss';


const propTypes = {
  externalLogin: PropTypes.func.isRequired,
  externalJwtLogin: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

const ExternalLoginPage = ({ externalLogin, externalJwtLogin, location }) => {
  const params = new URLSearchParams(location.search);
  const token = params.get('token');
  const RNAuth = params.get('rnAuth');

  if (!isBrowserSupported()) {
    return (
      <BackgroundLayout>
        <BrowserNotSupported />
      </BackgroundLayout>
    );
  }

  useEffect(() => {
    RNAuth
      ? externalJwtLogin(token)
      : externalLogin(token);
  }, []);

  return (
    <div className={ theme.loader }>
      <Loader />
    </div>
  );
};

ExternalLoginPage.propTypes = propTypes;

export default compose(
  connect(null, {
    externalLogin,
    externalJwtLogin,
  }),
)(ExternalLoginPage);
